<template>
  <input ref="inputRef" type="text">
</template>

<script>
import { useCurrencyInput } from 'vue-currency-input';

export default {
  name: 'CurrencyInput',
  props: {
    modelValue: { type: Number, required: true },
    options: {
      type: Object,
      default: () => {
      },
    },
  },
  setup(props) {
    const { inputRef } = useCurrencyInput(props.options);

    return { inputRef };
  },
};
</script>
